import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import SmoothScroll from "@/components/SmoothScroll";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { FloatingActions } from "@/components/FloatingActions";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Physiotherapy from "@/pages/Physiotherapy";
import SpeechHearing from "@/pages/SpeechHearing";
import HomeVisits from "@/pages/HomeVisits";
import Specialists from "@/pages/Specialists";
import Conditions from "@/pages/Conditions";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll>
          <Navbar />
          <main>
            <AnimatePresence mode="wait">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/physiotherapy" element={<Physiotherapy />} />
                <Route path="/speech-hearing" element={<SpeechHearing />} />
                <Route path="/home-visits" element={<HomeVisits />} />
                <Route path="/specialists" element={<Specialists />} />
                <Route path="/conditions" element={<Conditions />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
            </AnimatePresence>
          </main>
          <Footer />
          <FloatingActions />
          <Toaster position="top-center" richColors />
        </SmoothScroll>
      </BrowserRouter>
    </div>
  );
}

export default App;
